// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3sQSD","col":"Table_col__3BGML","fulfillmentStatus":"Table_fulfillmentStatus__3AgTx","emailCol":"Table_emailCol__12jX4"};